import type { JSX } from 'react';
import React from 'react';

import type { SVGProps } from './_types';

// Exported from Figma: ADX-onboarding-applications, node 13894:37134.
export default function MobileNotSupported(props: SVGProps): JSX.Element {
  const { title = 'Mobile not supported', ...restProps } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 317 196"
      fill="none"
      {...restProps}
    >
      <title>{title}</title>
      <g clipPath="url(#mobile-not-supported-clip)">
        <path
          d="M282.515 122.394H224.486V180.423H282.515V122.394Z"
          stroke="#5580F6"
          strokeWidth="1.9657"
          strokeMiterlimit="10"
        />
        <path
          d="M268.001 122.394V180.423"
          stroke="#5580F6"
          strokeWidth="1.9657"
          strokeMiterlimit="10"
        />
        <path
          d="M253.488 122.394V180.423"
          stroke="#5580F6"
          strokeWidth="1.9657"
          strokeMiterlimit="10"
        />
        <path
          d="M238.974 122.394V180.423"
          stroke="#5580F6"
          strokeWidth="1.9657"
          strokeMiterlimit="10"
        />
        <path
          d="M282.49 165.986H224.486"
          stroke="#5580F6"
          strokeWidth="1.9657"
          strokeMiterlimit="10"
        />
        <path
          d="M282.49 151.472H224.486"
          stroke="#5580F6"
          strokeWidth="1.9657"
          strokeMiterlimit="10"
        />
        <path
          d="M282.49 136.974H224.486"
          stroke="#5580F6"
          strokeWidth="1.9657"
          strokeMiterlimit="10"
        />
        <path
          d="M282.49 122.46H224.486"
          stroke="#5580F6"
          strokeWidth="1.9657"
          strokeMiterlimit="10"
        />
        <path
          d="M80.3817 26.0759H236.825C238.636 26.0759 240.11 27.5506 240.11 29.3616V152.508H77.0961V29.3357C77.0961 27.5247 78.5707 26.05 80.3817 26.05V26.0759Z"
          fill="white"
        />
        <path
          d="M109.642 26.1743V152.503"
          stroke="black"
          strokeWidth="1.9657"
          strokeMiterlimit="10"
        />
        <path
          d="M77.0961 57.9097H109.875"
          stroke="black"
          strokeWidth="1.9657"
          strokeMiterlimit="10"
        />
        <path
          d="M77.0961 69.1003H109.875"
          stroke="black"
          strokeWidth="1.9657"
          strokeMiterlimit="10"
        />
        <path
          d="M77.0961 80.3096H109.875"
          stroke="black"
          strokeWidth="1.9657"
          strokeMiterlimit="10"
        />
        <path
          d="M104.675 42.0615L93.0329 34.7141L81.365 42.0615L93.0329 49.4089L104.675 42.0615Z"
          fill="black"
        />
        <path
          d="M144.077 71.022H120.198"
          stroke="black"
          strokeWidth="1.5264"
          strokeMiterlimit="10"
        />
        <path
          d="M200.967 80.4456H190.179"
          stroke="black"
          strokeWidth="1.5264"
          strokeMiterlimit="10"
        />
        <path
          d="M131.012 80.4456H120.198"
          stroke="black"
          strokeWidth="1.31943"
          strokeMiterlimit="10"
        />
        <path
          d="M131.012 95.7219H120.198"
          stroke="black"
          strokeWidth="1.31943"
          strokeMiterlimit="10"
        />
        <path
          d="M230.409 36.1243C231.295 36.1243 232.013 35.4061 232.013 34.5203C232.013 33.6344 231.295 32.9163 230.409 32.9163C229.523 32.9163 228.805 33.6344 228.805 34.5203C228.805 35.4061 229.523 36.1243 230.409 36.1243Z"
          fill="black"
          stroke="black"
          strokeWidth="1.31943"
          strokeMiterlimit="10"
        />
        <path
          d="M224.872 36.1243C225.758 36.1243 226.476 35.4061 226.476 34.5203C226.476 33.6344 225.758 32.9163 224.872 32.9163C223.986 32.9163 223.268 33.6344 223.268 34.5203C223.268 35.4061 223.986 36.1243 224.872 36.1243Z"
          fill="black"
          stroke="black"
          strokeWidth="1.31943"
          strokeMiterlimit="10"
        />
        <path
          d="M219.31 36.1243C220.196 36.1243 220.914 35.4061 220.914 34.5203C220.914 33.6344 220.196 32.9163 219.31 32.9163C218.424 32.9163 217.706 33.6344 217.706 34.5203C217.706 35.4061 218.424 36.1243 219.31 36.1243Z"
          fill="black"
          stroke="black"
          strokeWidth="1.31943"
          strokeMiterlimit="10"
        />
        <path
          d="M234.496 45.6626C235.376 45.6626 236.1 46.2835 236.1 47.0338V53.7085C236.1 54.4588 235.376 55.0797 234.496 55.0797H116.912C116.032 55.0797 115.308 54.4588 115.308 53.7085V47.0338C115.308 46.2835 116.032 45.6626 116.912 45.6626H234.496Z"
          stroke="black"
          strokeWidth="1.9657"
          strokeMiterlimit="10"
        />
        <path
          d="M234.962 62.7695C235.583 62.7695 236.075 63.2352 236.075 63.8044V107.139C236.075 107.708 235.583 108.173 234.962 108.173H116.783C116.162 108.173 115.67 107.708 115.67 107.139V63.8044C115.67 63.2352 116.162 62.7695 116.783 62.7695H234.962Z"
          fill="#5580F6"
        />
        <path
          d="M180.012 80.4456H134.763C134.449 80.4456 134.194 80.7004 134.194 81.0147V83.7571C134.194 84.0714 134.449 84.3262 134.763 84.3262H180.012C180.326 84.3262 180.581 84.0714 180.581 83.7571V81.0147C180.581 80.7004 180.326 80.4456 180.012 80.4456Z"
          stroke="black"
          strokeWidth="1.80844"
          strokeMiterlimit="10"
        />
        <path
          d="M215.352 84.3616H229.917C230.346 84.3616 230.693 84.0141 230.693 83.5854V81.257C230.693 80.8284 230.346 80.4809 229.917 80.4809H215.352C214.923 80.4809 214.576 80.8284 214.576 81.257V83.5854C214.576 84.0141 214.923 84.3616 215.352 84.3616Z"
          stroke="black"
          strokeWidth="1.80844"
          strokeMiterlimit="10"
        />
        <path
          d="M215.352 71.022H229.917C230.346 71.022 230.693 70.6745 230.693 70.2458V67.9174C230.693 67.4888 230.346 67.1413 229.917 67.1413H215.352C214.923 67.1413 214.576 67.4888 214.576 67.9174V70.2458C214.576 70.6745 214.923 71.022 215.352 71.022Z"
          stroke="black"
          strokeWidth="1.80844"
          strokeMiterlimit="10"
        />
        <path
          d="M190.93 71.022H205.495C205.924 71.022 206.271 70.6745 206.271 70.2458V67.9174C206.271 67.4888 205.924 67.1413 205.495 67.1413H190.93C190.501 67.1413 190.153 67.4888 190.153 67.9174V70.2458C190.153 70.6745 190.501 71.022 190.93 71.022Z"
          stroke="black"
          strokeWidth="1.80844"
          strokeMiterlimit="10"
        />
        <path
          d="M180.012 95.7219H134.763C134.449 95.7219 134.194 95.9768 134.194 96.2911V99.0334C134.194 99.3478 134.449 99.6026 134.763 99.6026H180.012C180.326 99.6026 180.581 99.3478 180.581 99.0334V96.2911C180.581 95.9768 180.326 95.7219 180.012 95.7219Z"
          stroke="black"
          strokeWidth="1.80844"
          strokeMiterlimit="10"
        />
        <path
          d="M215.352 99.6042H229.917C230.346 99.6042 230.693 99.2568 230.693 98.8281V96.4997C230.693 96.0711 230.346 95.7236 229.917 95.7236H215.352C214.923 95.7236 214.576 96.0711 214.576 96.4997V98.8281C214.576 99.2568 214.923 99.6042 215.352 99.6042Z"
          stroke="black"
          strokeWidth="1.80844"
          strokeMiterlimit="10"
        />
        <path
          d="M120.198 89.4817H230.693"
          stroke="black"
          strokeWidth="1.9657"
          strokeMiterlimit="10"
        />
        <path
          d="M100.691 123.92H83.3569"
          stroke="white"
          strokeWidth="1.81098"
          strokeMiterlimit="10"
        />
        <path
          d="M94.0676 111.688H83.3569"
          stroke="#5580F6"
          strokeWidth="1.81098"
          strokeMiterlimit="10"
        />
        <path
          d="M108.995 186.064C108.995 186.064 138.437 197.836 151.993 165.393"
          stroke="#5580F6"
          strokeWidth="1.9657"
          strokeMiterlimit="10"
        />
        <path
          d="M155.589 174.266L152.588 164.461L143.275 167.721"
          stroke="#5580F6"
          strokeWidth="1.9657"
          strokeMiterlimit="10"
        />
        <path
          d="M1.16418 42.1167C1.16418 42.1167 24.4741 18.9361 51.3801 42.1167C51.3801 42.1167 28.0702 65.2973 1.16418 42.1167Z"
          stroke="#5580F6"
          strokeWidth="1.9657"
          strokeMiterlimit="10"
        />
        <path
          d="M26.2591 51.4005C31.4601 51.4005 35.6763 47.2422 35.6763 42.1127C35.6763 36.9832 31.4601 32.825 26.2591 32.825C21.0582 32.825 16.842 36.9832 16.842 42.1127C16.842 47.2422 21.0582 51.4005 26.2591 51.4005Z"
          stroke="#5580F6"
          strokeWidth="1.9657"
          strokeMiterlimit="10"
        />
        <path
          d="M93.1105 196.035H33.5809C31.5112 196.035 29.8296 194.353 29.8296 192.283L29.8296 77.2084C29.8296 75.3198 31.356 73.7934 33.2446 73.7934L93.4468 73.7934C95.3354 73.7934 96.8618 75.3198 96.8618 77.2084L96.8618 192.283C96.8618 194.353 95.1802 196.035 93.1105 196.035Z"
          fill="#5580F6"
        />
        <path
          d="M80.2271 187.013C80.2271 187.013 80.4341 187.22 80.4341 187.35V187.919C80.4341 188.048 80.5376 188.152 80.6669 188.152H81.8829C82.0122 188.152 82.1157 188.048 82.1157 187.919V187.35C82.1157 187.22 82.2192 187.065 82.3227 187.013L82.659 186.832C82.659 186.832 82.9436 186.755 83.073 186.832L83.5904 187.117C83.5904 187.117 83.8491 187.117 83.9267 187.039L84.5217 186.004C84.5217 186.004 84.5476 185.746 84.4441 185.668L83.9267 185.383C83.9267 185.383 83.7197 185.151 83.7456 185.021C83.7456 185.021 83.7715 184.711 83.7456 184.4C83.7456 184.4 83.8491 184.349 83.9526 184.271L84.47 183.986C84.47 183.986 84.6252 183.779 84.5476 183.65L83.9526 182.615C83.9526 182.615 83.7456 182.46 83.6163 182.538L83.0988 182.822C83.0988 182.822 82.7884 182.874 82.6849 182.822L82.3486 182.641C82.3486 182.641 82.1416 182.434 82.1416 182.305V181.736C82.1416 181.606 82.0381 181.503 81.9088 181.503H80.6928C80.5635 181.503 80.46 181.606 80.46 181.736V182.305C80.46 182.434 80.3565 182.589 80.253 182.641L79.9167 182.822C79.9167 182.822 79.6321 182.9 79.5027 182.822L78.9853 182.538C78.9853 182.538 78.7266 182.538 78.649 182.615L78.054 183.65C78.054 183.65 78.0281 183.909 78.1316 183.986L78.649 184.271C78.649 184.271 78.856 184.504 78.8301 184.633C78.8301 184.633 78.8042 184.944 78.8301 185.254C78.8301 185.254 78.7266 185.306 78.6231 185.383L78.1057 185.668C78.1057 185.668 77.9505 185.875 78.0281 186.004L78.6231 187.039C78.6231 187.039 78.8301 187.194 78.9594 187.117L79.4769 186.832C79.4769 186.832 79.7873 186.78 79.8908 186.832L80.2271 187.013Z"
          fill="white"
        />
        <path
          d="M66.2564 187.169C66.2564 186.367 65.6872 185.721 64.937 185.565V183.884C64.937 183.082 64.3678 182.435 63.6175 182.28V181.581H62.9449V182.28C62.1946 182.435 61.6255 183.082 61.6255 183.884V185.565C60.8752 185.721 60.306 186.367 60.306 187.169C60.306 187.169 61.3667 187.195 62.2981 187.169C62.2981 187.687 62.7638 188.127 63.2812 188.127C63.7986 188.127 64.2643 187.713 64.2643 187.169C65.1957 187.169 66.2564 187.169 66.2564 187.169Z"
          fill="black"
        />
        <path
          d="M44.8869 181.596L41.9376 184.52V188.142H44.8869H47.8363V184.52L44.8869 181.596Z"
          fill="black"
        />
        <path
          d="M48.0169 81.2566L41.6009 77.2207L35.1848 81.2566L41.6009 85.3184L48.0169 81.2566Z"
          fill="black"
        />
        <path
          d="M54.485 161.315H72.75"
          stroke="black"
          strokeWidth="1.9657"
          strokeMiterlimit="10"
        />
        <path
          d="M48.6639 166.65H78.571"
          stroke="black"
          strokeWidth="1.9657"
          strokeMiterlimit="10"
        />
        <path
          d="M29.8555 90.6328H96.8359"
          stroke="black"
          strokeWidth="1.9657"
          strokeMiterlimit="10"
        />
        <path
          d="M88.5572 102.638H38.0308C37.6307 102.638 37.3064 102.962 37.3064 103.362V108.303C37.3064 108.704 37.6307 109.028 38.0308 109.028H88.5572C88.9573 109.028 89.2816 108.704 89.2816 108.303V103.362C89.2816 102.962 88.9573 102.638 88.5572 102.638Z"
          stroke="white"
          strokeWidth="1.9657"
          strokeMiterlimit="10"
        />
        <path
          d="M64.2384 152.341C72.8399 152.341 79.8128 145.368 79.8128 136.766C79.8128 128.165 72.8399 121.192 64.2384 121.192C55.6369 121.192 48.6639 128.165 48.6639 136.766C48.6639 145.368 55.6369 152.341 64.2384 152.341Z"
          fill="white"
        />
      </g>
      <path
        d="M58.137 130.809L70.2728 142.944"
        stroke="black"
        strokeWidth="1.96391"
        strokeMiterlimit="10"
      />
      <path
        d="M58.137 142.944L70.2728 130.809"
        stroke="black"
        strokeWidth="1.96391"
        strokeMiterlimit="10"
      />
      <defs>
        <clipPath id="mobile-not-supported-clip">
          <rect width="316.87" height="196" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
